import { getArticle } from '@/api/news';
import websiteConfig from '@/configs/websiteConfig';
import { watch, ref} from "vue";
import { nowLang, language} from "@/language";
import { useOffsetPagination} from "@vueuse/core";
export const articleList = ref({});
export const swiperRef = ref(null);
export let articleTypeList = ref([])
export let articleTypeMap = ref({})
export let newsTypeNameList = ref([]);
export let listPagination = ref([]); // 分页记录器
export const swiperConfig = {
    el: '.nav-pagination',
    clickable: true,
    bulletClass: 'news-nav-item',
    bulletActiveClass: 'active',
    renderBullet: function (index, className) {
        return (
            '<span class="' + className + '">' + newsTypeNameList.value[index] + '</span>'
        );
    },
};
export const handleArticleList = async articleTypeList => {
    let newArticleList = {};
    const allArticleListRes = await getArticle({
        ids: articleTypeList[0],
        orderBy: 'ORDER_INDEX',
        orderWay: 'DESC',
        gameId: websiteConfig.basic.gameId,
        page: 1,
    })
    if (+allArticleListRes.result === 1) {
        let articleListRes = allArticleListRes?.data?.data;
        articleTypeList.forEach(item => {
            if (+item === 0) return;
            newArticleList[item] = articleListRes.filter(
                article => item.split(',').map(Number).includes(+article.ARTICLE_TYPE_ID)
            );
        });
        newArticleList[articleTypeList[0]] = articleListRes;
    }
    return newArticleList;
};
watch(
    () => nowLang.value,
    async () => {
        listPagination.value = [];
        articleTypeMap.value = websiteConfig.news.type[nowLang.value] || {};
        let articleTypeMapKey = Object.keys(articleTypeMap.value);
        if (!articleTypeMapKey.length) {
            console.log('empty article type list')
            return;
        }
        articleTypeList.value = [
            articleTypeMapKey.join(','),
            ...articleTypeMapKey,
        ];
        newsTypeNameList.value = [language.getTextByKey('latest'), ...Object.values(articleTypeMap.value)];
        swiperRef.value?.pagination && swiperRef.value.pagination.render();
        articleList.value = await handleArticleList(articleTypeList.value);
        articleTypeList.value.forEach(item => {
            let {currentPage, pageCount, prev, next, currentPageSize} =
                useOffsetPagination({
                    total: articleList.value[item]?.length || 0,
                    page: 1,
                    pageSize: 10,
                });
            listPagination.value.push({
                type: item,
                currentPageSize,
                currentPage,
                pageCount,
                prev,
                next,
                changePage: function (targetCurrentPage) {
                    this.currentPage = targetCurrentPage;
                },
            });
        });
    }, {immediate: true}
)
